var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurgeryOnboarding = function SvgSurgeryOnboarding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.442 0c8.283 0 15 6.717 15 15 0 8.283-6.717 15-15 15-8.283 0-15-6.717-15-15 0-8.283 6.717-15 15-15Z",
    fill: "#7BB0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.442 0v30c-8.283 0-15-6.717-15-15 0-8.283 6.717-15 15-15Z",
    fill: "#0A1B57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.597 20.777a6.083 6.083 0 0 0-.644 2.53C5.643 27.341 10.231 30 15.442 30c5.21 0 9.799-2.66 12.488-6.693a6.133 6.133 0 0 0-.647-2.53c-2.02-3.984-7.34-3.324-8.027-4.347-.532-.795-.215-3.236-.252-3.864-2.49.237-4.613.184-7.103-.053-.034.629.256 3.122-.277 3.917-.687 1.023-6.006.363-8.027 4.347Z",
    fill: "#E09C5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.597 20.777a6.083 6.083 0 0 0-.644 2.53C5.643 27.341 10.231 30 15.442 30V12.717a42.105 42.105 0 0 1-3.538-.204c-.034.629.256 3.122-.277 3.917-.687 1.023-6.005.363-8.027 4.347h-.003Z",
    fill: "#C47A40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.936 8.96c-.16-.19-.388-.243-.626-.212.007-.222.01-.444.01-.663 0-1.275-.003-2.84-.45-3.731-.324-.653-.82-1.079-1.402-1.396-2.24-1.21-3.812-1.21-6.052 0-.585.317-1.078.743-1.402 1.396-.447.893-.45 2.459-.45 3.731 0 .22.003.441.01.663-.238-.03-.466.021-.626.213-.37.443-.207 1.405.154 2.089.132.252.29.465.524.625a.855.855 0 0 0 .29.139c.157.724.375 1.405.674 2.015.413.844.977 1.547 1.738 2.012 1.193.73 3.044.73 4.237 0 .761-.465 1.325-1.168 1.738-2.012.299-.61.517-1.294.675-2.015a.829.829 0 0 0 .29-.139c.233-.16.39-.376.523-.625.36-.684.52-1.646.151-2.09h-.006Z",
    fill: "#FDC484"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.134 2.286c-.586-.57-1.442-.9-2.527-1.081-.36-.062-1.997-.056-2.373.009-1.063.182-1.901.512-2.48 1.072-1.445 1.402-1.529 3.908-1.291 6.671.86-1.722 2.194-2.47 3.796-2.677.382-.05 1.944-.053 2.305-.01 1.63.195 2.992.94 3.867 2.687.234-2.764.15-5.269-1.294-6.67h-.003Z",
    fill: "#0F68EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.442 2.046c-.952 0-1.907.302-3.026.906-.585.317-1.078.743-1.402 1.396-.447.893-.45 2.459-.45 3.731 0 .22.003.441.01.663-.238-.031-.466.021-.626.212-.37.444-.207 1.405.154 2.09.132.252.29.465.524.625a.857.857 0 0 0 .29.139c.157.724.375 1.405.674 2.015.413.844.977 1.547 1.738 2.012.595.367 1.356.549 2.12.549V2.043l-.006.003Z",
    fill: "#E09C5E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.442 1.165c-.506 0-1.02.018-1.211.052-1.063.182-1.901.512-2.48 1.072-1.446 1.402-1.53 3.908-1.292 6.672.86-1.723 2.194-2.472 3.796-2.678.194-.025.697-.037 1.187-.04V1.165Z",
    fill: "#004AB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.328 16.1c-.758-.44-1.322-1.103-1.735-1.901-.268-.518-.471-1.368-.622-1.972 1.143-1.297 2.727-1.821 4.47-1.821 1.745 0 3.325.524 4.472 1.82-.151.608-.355 1.455-.623 1.973-.413.798-.973 1.46-1.731 1.901-1.19.69-3.039.69-4.228 0h-.003Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.328 16.1c-.758-.44-1.322-1.103-1.735-1.901-.268-.518-.471-1.368-.622-1.972 1.143-1.297 2.727-1.821 4.47-1.821v6.209c-.757 0-1.518-.173-2.113-.518v.003Z",
    fill: "#DDEAF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.597 20.778a6.084 6.084 0 0 0-.644 2.53C5.643 27.34 10.231 30 15.442 30c5.21 0 9.799-2.66 12.488-6.693a6.134 6.134 0 0 0-.647-2.53c-1.537-3.028-4.979-3.373-6.843-3.814-.484 1.6-2.462 2.798-4.832 2.798-2.37 0-4.412-1.239-4.853-2.878-1.762.49-5.53.687-7.158 3.895Z",
    fill: "#E8EDF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.758 16.88c-1.762.49-5.53.687-7.158 3.894a6.084 6.084 0 0 0-.644 2.53 14.983 14.983 0 0 0 11.783 6.674c-.524-1.719-3.931-12.923-3.978-13.102l-.003.003Z",
    fill: "#6BC7B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.126 16.88c1.762.49 5.53.687 7.158 3.894.379.746.616 1.633.644 2.53a14.983 14.983 0 0 1-11.784 6.674c.521-1.716 3.932-12.923 3.979-13.102l.003.003Z",
    fill: "#3D8EFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.597 20.778a6.084 6.084 0 0 0-.644 2.53C5.643 27.34 10.231 30 15.442 30V19.758c-2.33-.056-4.252-1.276-4.687-2.875-1.762.49-5.53.687-7.158 3.895Z",
    fill: "#D4DDE2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.758 16.88c-1.762.49-5.53.687-7.158 3.894a6.084 6.084 0 0 0-.644 2.53 14.983 14.983 0 0 0 11.783 6.674c-.524-1.719-3.931-12.923-3.978-13.102l-.003.003Z",
    fill: "#004AB3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.787 27.252c-.114-2.62-.068-2.647-.346-.253.114.086.228.17.346.253Z",
    fill: "#21564F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.097 27.252c.114-2.62.071-2.647.345-.253-.114.086-.227.17-.345.253Z",
    fill: "#2A7269"
  })));
};
export default SvgSurgeryOnboarding;